export default __webpack_public_path__ + "static/media/chip-card.daacb163.svg";